import { ObjectModel } from 'objectmodel';

const PaymentProfile = new ObjectModel({
  price: Number,
  currency: String
});

const PaymentDetail = new ObjectModel({
  id: String,
  name: String
});

export { PaymentProfile, PaymentDetail };
